exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".comparison-limit-wrapper{display:grid;grid-template-rows:max-content max-content;grid-row-gap:5px;justify-items:center;text-align:center;height:max-content;font-size:24px;font-weight:300;padding:2vw}", ""]);

// exports
